import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ClipboardList } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface GroupMeeting {
  number: number;
  title: string;
}

interface GroupMeetingListProps {
  meetings: GroupMeeting[];
  surveyResponses?: {
    meeting_number: number;
    created_at: string;
    group_id?: string | null;
  }[];
  groupId?: string;
}

export const GroupMeetingList = ({
  meetings,
  surveyResponses,
  groupId,
}: GroupMeetingListProps) => {
  const navigate = useNavigate();
  
  const handleSurveyClick = (meetingNumber: number) => {
    // Include groupId in navigation if available
    const path = groupId 
      ? `/admin/survey/${meetingNumber}?groupId=${groupId}`
      : `/admin/survey/${meetingNumber}`;
    navigate(path);
  };
  
  // Filter responses by groupId if provided
  const relevantResponses = groupId 
    ? surveyResponses?.filter(r => r.group_id === groupId)
    : surveyResponses;
  
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-medium">Gruppledarenkäter efter Gruppträffar</h2>
      <div className="grid gap-4">
        {meetings.map((meeting) => {
          const hasResponse = relevantResponses?.some(
            (response) => response.meeting_number === meeting.number
          );
          
          return (
            <Card key={meeting.number} className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium">
                    Träff {meeting.number}: {meeting.title}
                  </h3>
                  {hasResponse && (
                    <span className="text-sm text-green-600">✓ Enkät ifylld</span>
                  )}
                </div>
                <Button
                  onClick={() => handleSurveyClick(meeting.number)}
                  variant={hasResponse ? "outline" : "default"}
                >
                  <ClipboardList className="mr-2 h-4 w-4" />
                  {hasResponse ? "Visa enkät" : "Fyll i enkät"}
                </Button>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
